import { getStorageImageUrl } from "@shared/lib/image-utils";
import { initialsFor } from "@shared/lib/initials";
import { Avatar, AvatarFallback, AvatarImage } from "@ui/components/avatar";
import { cn } from "@ui/lib";

/** Stable hue per name so a retailer keeps its tile colour everywhere. */
function hueFor(name: string) {
	let hash = 0;
	for (const char of name) {
		hash = (hash * 31 + char.charCodeAt(0)) % 360;
	}
	return hash;
}

/**
 * Square tile for an organization: its uploaded logo, or a tinted monogram.
 * Users get round avatars (UserAvatar); organizations are squares so the two
 * never read as the same kind of thing.
 */
export function OrganizationLogo({
	name,
	logoUrl,
	className,
	...props
}: Omit<React.ComponentProps<typeof Avatar>, "size"> & {
	name: string;
	logoUrl?: string | null;
}) {
	return (
		<Avatar
			className={cn(
				"size-8 rounded-lg after:rounded-lg [&_[data-slot=avatar-fallback]]:rounded-lg [&_img]:rounded-lg",
				className,
			)}
			{...props}
		>
			<AvatarImage src={getStorageImageUrl(logoUrl) ?? undefined} />
			<AvatarFallback
				style={{ "--tile-hue": hueFor(name) } as React.CSSProperties}
				className="bg-[oklch(0.9_0.045_var(--tile-hue))] font-semibold text-[0.7em] text-[oklch(0.35_0.06_var(--tile-hue))] tracking-tight dark:bg-[oklch(0.34_0.05_var(--tile-hue))] dark:text-[oklch(0.9_0.04_var(--tile-hue))]"
			>
				{initialsFor(name)}
			</AvatarFallback>
		</Avatar>
	);
}
